






















































































import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ReportModule from '@/store/modules/Report';
import AuthModule from '@/store/modules/Auth';
import GameModule from '@/store/modules/Game';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import InvoiceBody from '@/components/Table/InvoiceBody.vue';
import LogBody from '@/components/Table/LogBody.vue';
import Pagination from '@/components/Pagination.vue';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import InvoiceData from '@/data/InvoiceData';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    InvoiceBody,
    LogBody,
  },
})
export default class Invoice extends Mixins(
  ToolMixin, ErrorHandleMixin, PaginationMixin,
) {
  ReportInstance = getModule(ReportModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  GameInstance = getModule(GameModule, this.$store);

  componentKey = 0;

  Criteria = {
    ...this.Period,
    page: 1,
    limit: 1000,
    sort: 'turnover',
    isSearch: false,
    gameName: 'TOTAL',
    products: 'TOTAL',
    role: this.AuthInstance.user.role,
    userId: this.AuthInstance.user._id,
    username: this.AuthInstance.user.username,
    source: this.AuthInstance.user.source,
  };

  DefaultGameList = [
    {
      name: {
        en: 'Total',
        th: 'ทั้งหมด',
      },
      prefix: 'total',
    },
  ]

  GameList: any = [];

  BreadcrumbList: any = [];

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 1000,
  }

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
    },
  ];

  type = '';

  WinLoseList: any = {};

  resultData: any = {};

  dataList: any = [];

  LoginName = '';

  TableHeadMember = [...InvoiceData.TableHeadMember];

  FilteredTableHeadMember: any = [...InvoiceData.TableHeadMember];

  TableHeadLog: any = [];

  mode = 'agent';

  dataKey = 'users';

  isMember = false;

  detailFooterCol = 0;

  totalLog = 0;

  summaryLog = 0;

  houseEdge = 0;

  startdate = '';

  enddate = '';

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchperiod() {
    const datestart = this.$moment(this.Period.start.date).format('L');
    this.startdate = this.$moment(datestart).format('DD-MM-YYYY');
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchperiod2() {
    const dateend = this.$moment(this.Period.end.date).format('L');
    this.enddate = this.$moment(dateend).format('DD-MM-YYYY');
  }

  created() {
    this.fetchWinLose();
  }

  initial() {
    this.currentTool = 'Today';
    this.Period = {
      start: {
        date: this.$moment().startOf('day').toDate(),
      },
      end: {
        date: this.$moment().endOf('day').toDate(),
      },
    };
    this.Criteria = {
      ...this.Period,
      page: 1,
      limit: 1000,
      sort: 'turnover',
      isSearch: false,
      gameName: 'TOTAL',
      products: 'TOTAL',
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
    };
    this.LoginName = '';
    this.isMember = false;
  }

  changePage(page: number) {
    this.PaginationDetail.current = page;
    this.calPagination({ ...this.paginationParams });
    if (this.isMember) this.fetchWinLose();
  }

  async fetchWinLose() {
    if (!this.isMember) {
      this.PaginationDetail.current = 1;
    }
    this.Criteria.isSearch = !!this.LoginName;
    const criteria: any = { ...this.Criteria, ...this.Period };
    criteria.products = criteria.gameName;
    this.GeneralInstance.toggleLoading(true);
    const res = await this.ReportInstance.FetchInvoice(criteria);
    if (res.code) {
      this.checkError(res);
      return false;
    }
    if (['COMPANY', 'SUPERADMIN', 'SUBCOMPANY'].includes(this.Criteria.role && this.AuthInstance.role)) {
      this.FilteredTableHeadMember[0] = [...InvoiceData.TableHeadMember[0]]
        .filter((item: any) => !item.isCompanyHidden);
    } else {
      this.FilteredTableHeadMember = [...InvoiceData.TableHeadMember];
      this.FilteredTableHeadMember[0] = [...InvoiceData.TableHeadMember[0]]
        .filter((item: any) => !item.isAnyHidden);
    }
    this.dataKey = 'users';
    this.type = 'dataInvoice';
    this.mode = this.isMember ? 'member' : 'agent';
    this.WinLoseList = { ...this.ReportInstance[this.type] };
    if (res.code) {
      this.checkError(res);
    } else if (!this.ReportInstance[this.type][this.dataKey]) {
      this.PaginationDetail.amount = 0;
      this.PaginationDetail.current = 0;
    } else {
      this.BreadcrumbList = [
        ...this.BreadcrumbDefault,
        ...this.WinLoseList.breadcrumb,
      ];
      await this.calPagination({
        instance: 'WinLoseList',
        dataKey: this.dataKey,
      });
      this.resultData = this.WinLoseList;
      if (this.type === 'dataWinLose') {
        this.resultData[this.dataKey]
          .sort((a, b) => (b.transaction.turnover - a.transaction.turnover));
      }
    }
    this.componentKey += 1;
    this.GeneralInstance.toggleLoading(false);
  }

  onSubmit() {
    this.fetchWinLose();
  }

  onReset() {
    this.initial();
    this.fetchWinLose();
  }

  handleSearch() {
    this.isMember = this.AuthInstance.user.role === 'ADMIN';
    this.Criteria.username = this.LoginName
      ? this.LoginName
      : this.AuthInstance.user.username;
  }

  handleFetchWinloseAgent(username, role, source,userId) {
    this.beforeFetch(username, role, source,userId);
  }

  handleBreadcrumb({ username, role, source }) {
    this.beforeFetch(username, role, source);
  }

  beforeFetch(username, role, source,userId?) {
    this.isMember = role === 'MEMBER';
    this.LoginName = '';
    this.Criteria.username = username;
    this.Criteria.source = source;
    this.Criteria.role = role;
    this.Criteria.userId = !userId ? this.AuthInstance.user._id : userId;
    this.PaginationDetail.current = 1;
    this.fetchWinLose();
  }
}
